// Print + PDF export utilities using browser print + html2pdf.js

import html2pdf from "html2pdf.js";

/**
 * Detect page size class from element content.
 * Returns the body class to add for correct @page size.
 */
function detectPrintSizeClass(el) {
  // Check for A5 landscape (InvoiceA5Landscape): width 210mm, minHeight 148mm
  if (el.querySelector('[class*="invoice-a5l"]') || el.querySelector('[style*="210mm"][style*="148mm"]')) {
    return "print-size-a5-landscape";
  }
  // Check for A5 portrait (PhieuXuatKhoA5Single): width 148mm
  if (el.querySelector('[style*="148mm"]')) {
    return "print-size-a5-portrait";
  }
  // Check for thermal 80mm
  if (el.querySelector('.thermal-80mm')) {
    return "print-size-80mm";
  }
  // A4 là mặc định cho invoice-a4 và phiếu xuất kho A4
  return "print-size-a4";
}

/**
 * Print an element by opening a print-friendly dialog.
 * Uses CSS @media print to hide the rest of the page.
 */
export function printElement(elementId, options = {}) {
  const el = document.getElementById(elementId);
  if (!el) return;

  // Tạm thời đưa print-area ra ngoài modal để tránh bị clip bởi overflow/max-height
  const originalParent = el.parentNode;
  const placeholder = document.createElement("div");
  originalParent.insertBefore(placeholder, el);
  document.body.appendChild(el);

  document.body.classList.add("printing-mode");

  // Thêm class @page size đúng theo format
  const sizeClass = options.format
    ? (options.format === "80mm" ? "print-size-80mm"
      : (options.format === "a5l" || options.format === "a5") ? "print-size-a5-landscape"
      : options.format === "a4" ? "print-size-a4"
      : detectPrintSizeClass(el))
    : detectPrintSizeClass(el);

  if (sizeClass) document.body.classList.add(sizeClass);

  setTimeout(() => {
    window.print();
    setTimeout(() => {
      // Trả về vị trí cũ
      originalParent.insertBefore(el, placeholder);
      placeholder.remove();
      document.body.classList.remove("printing-mode");
      if (sizeClass) document.body.classList.remove(sizeClass);
    }, 500);
  }, 100);
}

/**
 * Export an element to PDF using html2pdf.js
 * @param elementId - target div id
 * @param filename - name of pdf file
 * @param options.format - 'a4' (default) | 'a5l' | '80mm'
 */
export async function exportPDF(elementId, filename = "document.pdf", options = {}) {
  const el = document.getElementById(elementId);
  if (!el) return;

  const isThermal = options.format === "80mm";
  const isA5Landscape = options.format === "a5l" || options.format === "a5"; // a5 = phiếu XK ngang
  const isA5Portrait  = false; // không dùng nữa

  // A5 landscape: width=210mm≈794px
  // A4 portrait:  width=210mm≈794px
  const canvasWidth = isThermal ? 302 : 794;

  const opt = {
    margin: isThermal ? [3, 2, 3, 2] : 0,
    filename,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff",
      width: canvasWidth,
      windowWidth: canvasWidth,
    },
    jsPDF: isThermal
      ? { unit: "mm", format: [80, 297], orientation: "portrait" }
      : isA5Landscape
      ? { unit: "mm", format: "a5", orientation: "landscape" }
      : { unit: "mm", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  await html2pdf().from(el).set(opt).save();
}